/**
 * Editor configuration. The startup level is the one level id the code may
 * name (SPEC §4.4). Everything else about levels comes from content.
 */
export const EDITOR_CONFIG = {
  /** Shown in the first boot line. Injected from package.json at build time. */
  version: __KN_VERSION__,
  /** Streamed as the final boot step, and the fallback for unknown deep links. */
  startupLevel: "riot-games",
  /** The boot screen stays up at least this long so its log can be read (A-23). */
  minBootDisplayMs: 1200,
} as const;
